<template>
	<v-dialog
		v-model="dialog"
		:width="$vuetify.breakpoint.lgAndUp? '33%':'auto'"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				color="success"
				dark
				v-bind="attrs"
				v-on="on"
				:block="!$vuetify.breakpoint.lgAndUp"
				@click="generarReporte"
			>
				<v-icon left>
					get_app
				</v-icon>
				Exportar
			</v-btn>
		</template>

		<v-card>
			<v-card-title class="text-center">
				{{messageDownload}}
			</v-card-title>
			<v-card-title class="text-center">
				<v-spacer/>
				<v-progress-circular
					:size="125"
					color="primary"
					indeterminate
					v-if="loading"
				/>
				<v-spacer/>
			</v-card-title>

			<v-card-text>
				<div v-if="reporte.total_results > max_reportes">
					No puedes descargar más de {{max_reportes}} registros, por favor acota el rango de búsqueda
				</div>
				<div v-if="reporte.total_results <= max_reportes && reporte.total_results!=-1">
					{{reporte.total_results}} registros están listos para ser descargados.
				</div>
			</v-card-text>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<json-csv
					:data="filedata"
					:fields="filefields"
					:labels="labels"
					:name="filename"
					delimiter=";"
					@export-finished="exported"
					v-if="reporte.total_results <= max_reportes"
				>
					<v-btn color="success" :disabled="!canDownload">
						Descargar Reporte
					</v-btn>
				</json-csv>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

import { getReporteVentas } from '@/library/api/reporte';
import { API } from 'aws-amplify';

import JsonCsv from 'vue-json-csv'


export default {
	name: 'DescargarReporte',
	components:{
		JsonCsv
	},
	props:{
		filtros:{
			type: Object,
			default:()=>{
				return {
					estado: [],
					medioPago: [],
					sucursal: [],
				}
			}
		},
		dateRange: Object,
		pagination: Object,
		headers: Array
	},
	computed: {
		messageDownload(){
			if( this.loading ){
				return 'Preparando reporte';
			}else if( this.reporte.total_results >= this.max_reportes ){
				return 'No se puede generar reporte';
			}else{
				return 'Reporte listo';
			}
		},
	  labels () {
	  	let labels = [];
	  	for( let head of this.headers ){
	  		if( head.value !== 'actions' ) 
	  		labels.push({[head.value]:head.text})
	  	}
	  	return labels;
	  },
	  filedata(){ return this.reporte.lista; },
	  filename(){
			const rut = (this.$store.getters['empresas/seleccionada']||{}).rut
	  	return `reporte_${rut}_${new Date().yyyymmdd()}.csv`;
	  }
		,loading(){	return this.estado === 'LOADING'	}
		,canDownload(){	return this.estado === 'CAN_DOWNLOAD'	}
		,error(){	return this.estado === 'ERROR'	}
	},
	data () {
		return {
			dialog: false,
			reporte: {
				lista: [],
				isloading: true,
				apiCall: null,
				total_results: -1,
			},
			estado: undefined,
			max_reportes: 2000,
			alerta:{
				active: false,
				text: undefined,
				type: undefined,
			}
		}
	},
	methods:{
		async generarReporte(){

			let vm = this;

			if( !vm.$store.getters['empresas/seleccionada'] ) return;

			vm.reporte.lista = [];
			vm.reporte.isloading = true;
			vm.reporte.total_results = -1;
			
			this.estado = 'LOADING';

			try{

				let estado = undefined;
				if( vm.filtros.estado.length > 0 ) estado = vm.filtros.estado.join(',');
				const contribuyente = vm.$store.getters['empresas/seleccionada'].rut;
				const filtros = { estado }
				const sortBy = this.pagination.sortBy.join(',');
				const sortDesc = this.pagination.sortDesc.join(',');
				const paginacion = { page:1, itemsPerPage:2000, sortBy, sortDesc }
				const from = vm.dateRange.from;
				const to = vm.dateRange.to;

				let resp = await getReporteVentas(contribuyente, from, to, paginacion, filtros);

				vm.reporte.lista = resp.reporte;

				vm.reporte.total_results = resp.reporte.length > 0? parseInt(resp.reporte[0].cantidad_total)||resp.reporte[0].cantidad_total: resp.reporte.length;

				let canDownload = true;

				if( canDownload ){
					this.estado = 'CAN_DOWNLOAD'
				}else{
					this.estado = 'ERROR'
				}
				
				this.estado === 'READY'

			}catch(err){

				console.error( 'hola soy download', err )

				if( !API.isCancel(err) ){
					this.estado = 'ERROR'
				}
				
			}
		},
		filefields: function(value,key){

			for( let head of this.headers ){

				if( head.value === key )	return true;
			}

			return false;

			// return key!== 'sucursal_sii' && key!== 'cantidad_total' && key!== 'pdf' && key !== 'revision_estado';
		},
		exported: function(){

			this.dialog = false;

			this.$emit('csv-exported')
		}
	}
}
</script>

<style lang="css" scoped>
</style>